import React, {useMemo, useState, useContext} from 'react'
import './DateTimeIndicator.scss'
import {Popover} from '@material-ui/core'
import ReservedForGantt from './ReservedForGantt'
import moment from 'moment'
import {ReservationContext} from './../../../context/Reservation'
import ApMath from '../../../utils/ApMath'
import {useModal} from '../../../common/Modal'

const SelectionRangeIndicator = ({items, startSec, endSec, primaryHeaders}) => {
  const simpleModal = useModal()
  const {reservation, update, reserveLimit} = useContext(ReservationContext)
  const width = useMemo(() => {
    if (!primaryHeaders.length) return 0

    const nearestIndex = primaryHeaders.findIndex(e => endSec >= e.sec && endSec <= e.endSec) // get first instance
    let right = 0

    // get percentage value
    if (nearestIndex !== -1) {
      const normNearest = primaryHeaders[nearestIndex].endSec - primaryHeaders[nearestIndex].sec
      const normStart = endSec - primaryHeaders[nearestIndex].sec
      const percStart = normStart / normNearest
      right =
        nearestIndex * primaryHeaders[nearestIndex].width +
        percStart * primaryHeaders[nearestIndex].width
    }

    const last = primaryHeaders[primaryHeaders.length - 1]

    return last.endSec < endSec ? primaryHeaders.length * last.width : right
  }, [endSec, primaryHeaders])

  const totalWidth = useMemo(() => {
    if (!primaryHeaders.length) return 0
    else {
      return primaryHeaders.length * primaryHeaders[0].width
    }
  }, [primaryHeaders])

  const startWidth = useMemo(() => {
    if (!primaryHeaders.length) return 0

    const nearestIndex = primaryHeaders.findIndex(e => startSec >= e.sec && startSec <= e.endSec) // get first instance
    let right = 0

    // get percentage value
    if (nearestIndex !== -1) {
      const normNearest = primaryHeaders[nearestIndex].endSec - primaryHeaders[nearestIndex].sec
      const normStart = startSec - primaryHeaders[nearestIndex].sec
      const percStart = normStart / normNearest
      right =
        nearestIndex * primaryHeaders[nearestIndex].width +
        percStart * primaryHeaders[nearestIndex].width
    }

    const last = primaryHeaders[primaryHeaders.length - 1]

    return last.endSec < startSec ? primaryHeaders.length * last.width : right
  }, [startSec, primaryHeaders])

  const checkAvailability = object => {
    let op = true
    object.events.forEach(ev => {
      if (
        ev.type === 'SystemReservationAction' &&
        ApMath.isRangeOverlap(
          moment(ev.start).valueOf(),
          moment(ev.end).valueOf(),
          moment(reservation.date_from).valueOf(),
          moment(reservation.date_to)
            .subtract(1, 'second')
            .valueOf()
        ) &&
        ev.raw?.status !== 'fullfilled' &&
        ev.raw?.state !== 'returned'
      ) {
        op = false
      }
    })
    return op
  }

  const handleClick = (e, object) => {
    let _items = [...reservation.selected_items]
    if (checkAvailability(object)) {
      const index = _items.findIndex(f => f.id === object.id)
      if (index !== -1) {
        _items.splice(index, 1)
      } else {
        _items.push(object)
      }
    }

    if (_items.length > reserveLimit) {
      if (simpleModal) {
        simpleModal.show({
          title: 'Reservation Limit',
          description: `Can't reserve more than ${reserveLimit} items.`,
          buttons: {
            affirmative: {
              label: 'OK',
            },
          },
        })
      }
      return
    }

    if (object.disabled === undefined) {
      update('selected_items', _items)
    }
    // if (!reservation.reserved_for.name) {
    //   setOpenReserveForPopOver(e.currentTarget)
    // }
    update('fromGantt', true)
  }

  const isSelected = id => {
    let op = false
    reservation.selected_items.map(i => {
      if (i.id === id) {
        op = true
      }
      return true
    })
    return op
  }

  return (
    <div
      style={
        {
          //display: width === 0 ? 'none' : null,
        }
      }
      className=""
    >
      <div
        style={{width: width - startWidth, left: startWidth, zIndex: 999}}
        className={`ap-reservation-gantt-date-range-selector`}
      >
        {items.map((i, k) => {
          return (
            <div
              key={k}
              className="item_selector"
              style={{
                '--hover-bg': `${i.color}55`,
              }}
              onClick={e => {
                handleClick(e, i)
              }}
            >
              <div
                key={k}
                className="c-pill ap-typography ap-typography--xxs ap-ellipsis"
                style={{
                  borderRadius: 12,
                  textAlign: 'center',
                  backgroundColor: `${isSelected(i.id) ? i.color : 'unset'}`,
                  left: 0,
                  right: 0,
                  top: 4,
                  bottom: 4,
                  borderWidth: 0,
                }}
              >
                <span className="ap-ellipsis c-pill__label">
                  {isSelected(i.id) ? reservation.reserved_for.name : ''}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SelectionRangeIndicator
